import {
  Component,
  inject,
  signal,
  ChangeDetectionStrategy,
} from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { IHelpDocumentsFromProfile } from '../../../admin/countries/countries.models';
import { DsButtonModule } from '@bmw-ds/components';
import { UploadFilesService } from '../../../shared/upload-files/upload-files.service';

@Component({
  selector: 'tqc-help-document-download-cell-renderer',
  standalone: true,
  imports: [DsButtonModule],
  templateUrl: './action-cell-renderer.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class HelpDocumentDownloadCellRendererComponent implements ICellRendererAngularComp {
  public readonly loading = signal(false);
  private params!: ICellRendererParams<IHelpDocumentsFromProfile>;
  private readonly fileService = inject(UploadFilesService);
  agInit(params: ICellRendererParams<IHelpDocumentsFromProfile>): void {
    this.params = params;
  }
  refresh(): boolean {
    return false;
  }
  onDownload() {
    this.loading.set(true);
    this.fileService
      .getFiles([`${this.params.data!.fileId}:${this.params.data!.fileUuid}`])
      .subscribe({
        next: (res) => {
          const presignedUrl = res[0].preSignedUrl;
          const a = document.createElement('a');
          a.href = presignedUrl;
          let fileName = res[0].fileName;
          if (res[0].fileType.includes('pdf')) {
            fileName = `${fileName}.pdf`;
          }
          a.download = fileName;
          document.body.appendChild(a);
          a.click();
          a.remove();
          this.loading.set(false);
        },
      });
  }
}
